angular.module('tcApp')
.directive('tcMatches', function($mdMedia, GlobalService,tcConstants) {
	return {
		restrict: 'E',
		templateUrl: 'template/matches/matches.html',
		scope: {
			fieldId: '@',
			matches: '=',
			headers: '=',
			monitor: '=',
			headersNamed: '=',
			selectMatch: '&',
			highlightMatch: '&',
			matchIsActive: '&',
			prevPage: '&',
			nextPage: '&',
			listMoreRows: '=',
			pageNumber: '=',
			error: '=',
			customTemplateUrl: '=',
			modelClassName: '=',
			layoutPickerUrl: '=',
			tcMatchesAllowHtmlValues: '=',
			tcMatchesCloseLookup: '&',
			tcMatchesFilterComponent: '=',
			tcMatchesOpenFilterComponent: '&'
		},
		link: function(scope) {
			scope.globalStrings = GlobalService.getGlobalStrings();
			// Limit lookup columns based on screen size
			// Alternatively we can change the template to be responsive
			scope.getColumnLimit = function() {
				var columnLimit = null;
				if ($mdMedia('xs')) {
					columnLimit = 6;
				} else if ($mdMedia('sm')) {
					columnLimit = 10;
				} else if ($mdMedia('md')) {
					columnLimit = 15;
				} else {
					columnLimit = 20;
				}
				return columnLimit;
			};
			
			// Indicates if direction is Right-to-Left (RTL), to change CSS class used for alignment of lookups
			if (angular.isDefined(GlobalService.logonData)) {
				scope.isDirectionRTL = (GlobalService.logonData.langDirection === tcConstants.LANG_DIRECTION.RIGHT_TO_LEFT);
			} else {
				scope.isDirectionRTL = false;
			}
		},
	};
});
